/* eslint-disable */
import { useQuery } from 'vue-query';
import apiAxios from '../../apiAdminAxios';

const fetchTickets = async ({ page, per_page, search, search_status }) => {
  let URL = `?page=${page || 1}`;

  if (per_page) {
    URL += `&per_page=${per_page}`;
  }
  if (search) {
    URL += `&search=${search}`;
  }
  if (search_status) {
    URL += `&search_status=${search_status}`;
  }

  const { data } = await apiAxios.get(`/admin/tickets${URL}`);
  return data;
};

const changeTicketStatus = async ({ id, status, send_email }) => {
  let URL = `?status=${status}`;

  if (typeof send_email === 'boolean') {
    URL += `&send_email=${send_email ? 1 : 0}`;
  }

  const { data } = await apiAxios.post(`/admin/tickets/${id}/update-status${URL}`);

  return data;
};
const ticketComm = async ({ email }) => {
  let URL = `?email=${email}`;

  const { data } = await apiAxios.get(`/admin/tickets/mails${URL}`);

  return data;
};
const fetchHomeStatsAdmin = async (monthly = 0, monthBack = 0, year = 2025, employer_id = null) => {
  let URL = `/admin/stats/home/${monthly !== 0 ? '1' : ''}?month=${monthBack}&year=${year}`;
  if (employer_id) {
    URL += `&employer_id=${employer_id}`;
  }
  const { data } = await apiAxios.get(URL);
  return data;
};
const fetchTicketMessages = async (ticket_id) => {
  const { data } = await apiAxios.get(`/admin/tickets/messages/${ticket_id}`);
  return data;
};
const replyToTicket = async (ticket_id, formData) => {
  const { data } = await apiAxios.post(`/admin/tickets/${ticket_id}/messages/reply`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
};
// queries
const useTicketsQuery = ({ page, per_page, search, search_status }) =>
  useQuery(
    ['admin/tickets', page, per_page, search, search_status],
    () => fetchTickets({ page, per_page, search, search_status }),
    { refetchOnMount: false },
  );
const usefetchHomeStatsAdminQuery = (month, monthBack, year, employer_id) =>
  useQuery(
    ['home-stats-query', month, monthBack, year, employer_id],
    () => fetchHomeStatsAdmin(month, monthBack, year, employer_id),
    {
      cacheTime: 0,
      staleTime: 0,
    },
  );
export default {
  // queries
  useTicketsQuery,
  changeTicketStatus,
  usefetchHomeStatsAdminQuery,
  ticketComm,
  fetchTicketMessages,
  replyToTicket,
};
